var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"hidden-print-only",staticStyle:{"z-index":"0"},attrs:{"padless":"","absolute":""}},[_c('v-col',{staticClass:"text-right overline",attrs:{"cols":"12"}},[_vm._v(" Copyright Barangayan V 1.8.0 © "+_vm._s(new Date().getFullYear())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }